import { render, staticRenderFns } from "./SQuesTwentyOne.vue?vue&type=template&id=6aa1047c&"
import script from "./SQuesTwentyOne.vue?vue&type=script&lang=js&"
export * from "./SQuesTwentyOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports